module.exports = __webpack_public_path__ + "img/듀란달.2b63d608.png";